import {useEffect, useState} from 'react';

/**
 * CMS article layouts only (`blog_article_img`, `blog_article_content` → matching `page--blog-*` body classes).
 * Excludes blog landing, editorial listing, and generic `page--blog-page`.
 */
const BLOG_ARTICLE_BODY_CLASSES = ['page--blog-article-img', 'page--blog-article-content'];

const isBlogArticleLayoutBody =
  typeof document === 'undefined'
    ? () => false
    : () => BLOG_ARTICLE_BODY_CLASSES.some((cls) => document.body?.classList?.contains(cls));

/**
 * True when the current route is a blog *article* page (img or content layout).
 */
export const useBlogArticlePageBody = () => {
  const [active, setActive] = useState(() => isBlogArticleLayoutBody());

  useEffect(() => {
    const read = () => isBlogArticleLayoutBody();

    setActive(read());

    const observer = new MutationObserver(() => setActive(read()));
    observer.observe(document.body, {attributes: true, attributeFilter: ['class']});

    return () => observer.disconnect();
  }, []);

  return active;
};
